import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';
import { mentionSearchService } from '../services/mentionSearchService';

/**
 * Migration utility to populate userSearchIndex collection
 * Run this once to index all existing users for mention search
 */
export async function migrateUserSearchIndex(): Promise<{ success: number; failed: number }> {
  console.log('Starting user search index migration...');

  const usersRef = collection(db, 'users');
  const snapshot = await getDocs(usersRef);

  let success = 0;
  let failed = 0;

  for (const doc of snapshot.docs) {
    const user = doc.data();
    try {
      await mentionSearchService.indexUser(
        doc.id,
        user.displayName || user.email,
        user.email,
        true,  // isApproved - set to true so users can be found in search
        user.personId,
        user.personName,
        user.photoURL
      );
      success++;
      console.log(`✓ Indexed user: ${user.displayName || user.email}`);
    } catch (error) {
      console.error(`✗ Failed to index user ${user.email}:`, error);
      failed++;
    }
  }

  console.log(`Migration complete: ${success} success, ${failed} failed`);
  return { success, failed };
}
